import { usePlatformMe } from '../../shared/api/usePlatformMe.js';
import { resolveDashboardKind } from '../../shared/nav/resolve-role.js';
import { RequestsKanbanPage } from '../requests-kanban/RequestsKanbanPage.js';
import { MyRequestsPage } from './MyRequestsPage.js';

/**
 * Роль-зависимый экран «Заявки» на общем ключе `requests` (один поддомен на
 * отель, роль-роутинг).
 *
 * Канбан заявок отеля (#34: колонки по статусу, drag&drop, SLA, фильтр по
 * типу) видят менеджмент (manager/owner) И персонал отдела (kind 'staff':
 * кухня/бар/хаускипинг/ресепшн). Видимость заявок фильтруется НА БЭКЕ по
 * отделу (feat/kanban-department-visibility): GET /v1/admin/requests отдаёт
 * менеджменту все заявки тенанта, а персоналу отдела — только заявки его
 * отдела (+ общий пул guest_services). Поэтому фронту достаточно показать
 * всем staff/management один и тот же канбан — каждый увидит свой срез.
 * Гость канбан не получает — у него «Мои заявки» (ownership /v1/me/requests).
 */
export function RequestsByRole(): JSX.Element {
  const { data } = usePlatformMe();
  const roles = data?.actor.roles ?? [];
  const kind = data ? resolveDashboardKind(roles) : 'guest';
  if (kind === 'manager' || kind === 'owner' || kind === 'staff') {
    return <RequestsKanbanPage />;
  }
  // Гость — «Мои заявки» (свои обращения, ownership на бэке /v1/me/requests).
  return <MyRequestsPage />;
}
